import styled, { Scale, Typography } from '@secretescapes/falcon';
import { type CommonStyledProps } from '@utils/styles.utils';

export const Section = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.m};
`;

export const Container = styled('div')<CommonStyledProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ isMobile }) => (isMobile ? Scale.m : Scale.l)};
`;

export const StyledList = styled('ul')<CommonStyledProps>`
  display: ${({ isMobile }) => (isMobile ? 'flex' : 'grid')};
  flex-direction: column;
  grid-template-columns: repeat(3, auto);
  gap: ${({ isMobile }) => (isMobile ? Scale.m : Scale.l)};
  padding: 0;
  margin: 0;
`;

export const StyledModalList = styled('ul')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.m};
  padding: 0;
  margin: 0 0 0 ${Scale.s};
`;

export const TypographyWithLink = styled(Typography)`
  && a {
    text-decoration: underline;
    color: ${({ theme }) => theme.color.secondary60};
  }
`;

export const GroupedFacilitiesSectionsFlexbox = styled('div')`
  display: flex;
  gap: ${Scale.l};
  flex-direction: column;
`;

export const TypographyIconFlexbox = styled('div')`
  display: flex;
  gap: ${Scale.xs};
  flex-direction: row;
  align-items: center;
`;
